import { createReducer } from '@reduxjs/toolkit';
import { updateNatalChart } from './actions';

import { natalChartInitialState } from './state';

export const natalChartReducer = createReducer(natalChartInitialState, (builder) => {
  builder.addCase(updateNatalChart, (state, { payload }) => ({
    ...state,
    ...payload,
  }));
});
